<template>
  <div class="transfer-inventory-page animated fadeIn">
    <b-row>
      <b-col cols="12">
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="transfer-inventory-card"
          >
            <component-new-header
              title="Transfer Inventory"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="false"
              :hasback="false"
            />
            <div class="transfer-inventory-form">
              <!-- Transfer From Section -->
              <div class="form-section">
                <h6 class="form-section-title">Transfer From</h6>
                <b-row>
                  <b-col cols="12" md="6" lg="5" class="form-group-col">
                    <b-form-group
                      label="From Warehouse"
                      label-for="from-warehouse"
                      :label-cols="12"
                      label-cols-md="4"
                      label-cols-lg="3"
                      class="mb-0"
                    >
                      <eb-select
                        type="text"
                        :options="stockOptions"
                        label="label"
                        placeholder="Select From Warehouse"
                        @input="changeStockpoint"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" lg="5" class="form-group-col">
                    <b-form-group
                      label="Item"
                      label-for="from-item"
                      :label-cols="12"
                      label-cols-md="4"
                      label-cols-lg="3"
                      class="mb-0"
                    >
                      <eb-select
                        ref="fromItem"
                        type="text"
                        :options="itemList"
                        v-model="fromItem"
                        label="label"
                        placeholder="Select Item"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <!-- Transfer To Section -->
              <div class="form-section">
                <h6 class="form-section-title">Transfer To</h6>
                <b-row>
                  <b-col cols="12" md="6" lg="5" class="form-group-col">
                    <b-form-group
                      label="To Warehouse"
                      label-for="to-warehouse"
                      :label-cols="12"
                      label-cols-md="4"
                      label-cols-lg="3"
                      class="mb-0"
                    >
                      <eb-select
                        ref="toStockOptions"
                        type="text"
                        :options="tostockOptions"
                        label="label"
                        placeholder="Select To Warehouse"
                        @input="changeToStockpoint"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" lg="5" class="form-group-col">
                    <b-form-group
                      label="Item"
                      label-for="to-item"
                      :label-cols="12"
                      label-cols-md="4"
                      label-cols-lg="3"
                      class="mb-0"
                    >
                      <eb-select
                        ref="toItem"
                        type="text"
                        :options="itemList"
                        v-model="toItem"
                        label="label"
                        placeholder="Select Item"
                      ></eb-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <!-- Quantity & Quick Load -->
              <div class="form-section">
                <h6 class="form-section-title">Quantity</h6>
                <b-row class="align-items-end action-row">
                  <b-col cols="12" md class="form-group-col mb-2 mb-md-0">
                    <b-form-group class="mb-0">
                      <c-input
                        :inputType="'number'"
                        inputId="Quantity"
                        v-model="quantityValue"
                        labelText="Quantity"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="auto" class="form-group-col btn-col">
                    <b-button
                      variant="primary"
                      class="action-btn action-btn-align w-100 w-md-auto"
                      :disabled="
                        !(
                          fromItem &&
                          fromItem._id &&
                          providerId &&
                          stockPointId &&
                          toStockPointId &&
                          toItem &&
                          toItem._id &&
                          toProviderId &&
                          quantityValue
                        )
                      "
                      @click="quickLoadInventory"
                      >Quick Load</b-button
                    >
                  </b-col>
                </b-row>
              </div>

              <!-- Bulk Transfer Section -->
              <div class="form-section">
                <h6 class="form-section-title">Bulk Transfer (Excel)</h6>
                <b-row class="align-items-end action-row">
                  <b-col cols="12" md class="form-group-col mb-2 mb-md-0">
                    <b-form-group
                      label="Template File"
                      label-for="template-file"
                      :label-cols="12"
                      label-cols-md="4"
                      label-cols-lg="3"
                      class="mb-0"
                    >
                      <b-form-file
                        placeholder="Select a Template"
                        @change="selectFile"
                        drop-placeholder="Drop file here..."
                      ></b-form-file>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="auto" class="form-group-col btn-col">
                    <b-button
                      variant="primary"
                      class="action-btn action-btn-align w-100 w-md-auto"
                      :disabled="!itemId || itemId === ''"
                      @click="uploadFile"
                      >Transfer Inventory</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import { itemFindByOption } from "@/services/item";
import { getPartnerParentData } from "@/services/partner.ts";
import componentNewHeader from "@/components/componentNewHeader";
export default {
  name: "TransferInventory",
  components: {
    ebSelect,
    loader,
    cInput,
    componentNewHeader,
  },
  data: () => {
    return {
      loading: false,
      itemId: "",
      providerId: "",
      stockPointId: "",
      selectedFile: null,
      tostockOptions: [],
      toItem: {},
      fromItem: {},
      toStockPointId: null,
      toProviderId: null,
      quantityValue: "",
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      DownloadTemplate: "inventory/downloadInventoryTemplate",
      UploadFile: "inventory/uploadFileToStorage",
      LoadInventory: "inventory/loadInventory",
      TransferInventory: "inventory/transferInventory",
      TransferInventoryQuick: "inventory/transferInventoryQuick",
    }),
    quickLoadInventory() {
      let payload = {
        itemId: this.fromItem._id,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        transferToItem: this.toItem._id,
        transferToProvider: this.toProviderId,
        transferToStockPoint: this.toStockPointId,
        transferUnit: Number(this.quantityValue),
      };
      this.TransferInventoryQuick(payload)
        .then((res) => {
          this.loading = false;
          if (res.error) {
            this.$swal({
              type: "error",
              text: res.message,
            });
            return;
          }
          this.$swal({
            type: "success",
            text: "Inventory Transferred Successfully!",
          });
          this.quantityValue = null;
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            type: "error",
            text: "Failed to transfer inventory",
          });
        });
    },
    async changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        this.getToStockPoints(data._id);
        this.stockPointId = data._id;
        const stockpointParentData = await getPartnerParentData(data._id).then(
          (x) => x.response
        );
        this.providerId = stockpointParentData._id;
        let payload = { needInventory: true };
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = stockpointParentData._id;
        }
        await this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
        this.$refs.fromItem.reset();
      }
    },
    async changeToStockpoint(data) {
      if (data !== null) {
        this.toStockPointId = data._id;
        const stockpointParentData = await getPartnerParentData(data._id).then(
          (x) => x.response
        );
        this.toProviderId = stockpointParentData._id;
        this.getToItem({
          _id: data._id,
          providerId: stockpointParentData._id,
        });
      }
    },
    getToStockPoints(Id) {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let newData = data.filter((Obj) => Obj._id !== Id);
      let userId = this.$store.getters["auth/getUserID"];
      this.tostockOptions = newData.map((obj) => ({
        _id: obj._id,
        providerId: obj.parentPartner || userId,
        label: obj.office?.officeName || "",
      }));
      this.$refs.toStockOptions.reset();
    },
    async getToItem(data) {
      let itemsData = await itemFindByOption({
        needInventory: true,
        provider: data.providerId,
      });
      this.toItems = itemsData.response.map((obj) => ({
        _id: obj._id,
        providerId: obj.provider,
        label: obj.description_summary,
      }));
      this.$refs.toItem.reset();
    },

    downloadTemplate() {
      this.loading = true;
      this.DownloadTemplate(this.itemId)
        .then((res) => {
          this.loading = false;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            window.URL.createObjectURL(new Blob([res]))
          );
          element.setAttribute("download", `${this.itemId}_template.xls`);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(() => (this.loading = false));
    },
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("file", this.selectedFile);
      formdata.append(
        "key",
        (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase()
      );
      formdata.append("isPublic", true);
      formdata.append("replaceExisting", true);
      formdata.append("basePath", "inventory");
      await this.UploadFile(formdata)
        .then((res) => {
          this.updateInventory(res.data.fileUrl);
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            text: "File Upload failed! please try again.",
          });
          this.loading = false;
        });
    },
    updateInventory(fileUrl) {
      let payload = {
        itemId: this.itemId,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        fileUrl: fileUrl,
        transferToStockPoint: this.toStockPointId,
      };
      this.TransferInventory(payload)
        .then((res) => {
          this.loading = false;
          this.$swal({
            type: "success",
            text: "Inventory Stock Transferred Successfully!",
          });
        })
        .catch(() => (this.loading = false));
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        let stockpoints = data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
        return stockpoints;
      } else {
        return [];
      }
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        let items = data.map((obj) => ({
          _id: obj._id,
          providerId: obj.provider,
          label: obj.description_summary,
        }));
        return items;
      } else {
        return [];
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant");
  },
};
</script>
<style lang="sass" scoped>
.transfer-inventory-page
  padding: 0 0.5rem

.transfer-inventory-card
  min-height: 480px
  border-radius: 8px
  overflow: hidden
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08)

  ::v-deep .card-body
    padding: 1.25rem

.form-section
  margin-bottom: 1.5rem
  padding-bottom: 1.25rem
  border-bottom: 1px solid rgba(0, 0, 0, 0.06)

  &:last-of-type
    border-bottom: none
    margin-bottom: 0
    padding-bottom: 0

.form-section-title
  font-size: 0.875rem
  font-weight: 600
  color: #495057
  margin-bottom: 1rem
  text-transform: uppercase
  letter-spacing: 0.025em

.form-group-col
  padding-left: 0.5rem
  padding-right: 0.5rem

/* Fixed-width button column for perfect alignment across rows */
.action-row .btn-col
  display: flex
  justify-content: flex-end
  align-items: flex-end
  padding-bottom: 0.25rem

  @media (min-width: 768px)
    flex: 0 0 200px
    max-width: 200px

.action-btn
  min-height: 44px
  padding: 0.5rem 1.25rem
  font-weight: 500
  white-space: nowrap

  &.action-btn-align
    width: 100%
    max-width: 200px

  &.w-100.w-md-auto
    @media (min-width: 768px)
      width: 100% !important
      max-width: 200px

/* Responsive: Tablet and up */
@media (min-width: 768px)
  .transfer-inventory-page
    padding: 0 1rem

  .transfer-inventory-card
    min-height: 560px

  .transfer-inventory-card ::v-deep .card-body
    padding: 1.5rem

  .form-section
    margin-bottom: 1.75rem
    padding-bottom: 1.5rem

  .action-btn
    min-width: 140px

/* Responsive: Desktop */
@media (min-width: 992px)
  .transfer-inventory-card
    min-height: 520px

  .transfer-inventory-card ::v-deep .card-body
    padding: 2rem

  .form-section-title
    font-size: 0.9375rem

/* Mobile-first: small screens */
@media (max-width: 767.98px)
  .transfer-inventory-page
    padding: 0 0.25rem

  .transfer-inventory-card
    margin-left: -0.5rem
    margin-right: -0.5rem
    border-radius: 0
    min-height: auto

  .transfer-inventory-card ::v-deep .card-body
    padding: 1rem 1rem 1.5rem

  .form-section
    margin-bottom: 1.25rem
    padding-bottom: 1rem

  .form-section-title
    font-size: 0.8125rem
    margin-bottom: 0.75rem

  .form-group-col
    padding-left: 0.25rem
    padding-right: 0.25rem

  .action-btn.action-btn-align
    width: 100%
    max-width: 100%

/* Extra small devices */
@media (max-width: 375px)
  .transfer-inventory-card ::v-deep .card-body
    padding: 0.75rem 0.75rem 1rem

  .form-section-title
    font-size: 0.75rem
</style>
